import {
  createRequiredRule,
  createEmailRule,
  createUrlRule,
  createMinLengthRule,
  MIN_LENGTH_TYPE,
} from './validationUtils';

const ValidationPlugin = {
  install(Vue) {
    Object.defineProperty(Vue.prototype, '$validation', {
      get() {
        const t = this.$t.bind(this);
        
        return {
          // Pre-made rules for common cases (generic error messages)
          requiredRule: createRequiredRule(t),
          emailRule: createEmailRule(t),
          urlRule: createUrlRule(t),
          
          // Factory functions for custom error messages or labels
          createRequiredRule: (labelMessagePath, customErrorMessagePath) => createRequiredRule(
            t,
            labelMessagePath,
            customErrorMessagePath,
          ),
          createEmailRule: (customErrorMessagePath) => createEmailRule(t, customErrorMessagePath),
          createUrlRule: (customErrorMessagePath) => createUrlRule(t, customErrorMessagePath),
          createMinLengthRule: (minLength, type, labelMessagePath, customErrorMessagePath) => createMinLengthRule(
            t,
            minLength,
            type,
            labelMessagePath,
            customErrorMessagePath,
          ),
          
          // Constants
          MIN_LENGTH_TYPE,
        };
      },
    });
  },
};

export default ValidationPlugin;
